module.exports = __webpack_public_path__ + "static/img/11.cf05c27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/11.jpg
// module id = asM7
// module chunks = 1